'use strict';
var app = require('angular').module('dashboard');

app.controller('dashboardFormCtrl', ['Department', 'dialog', 'forms', '$state', 'teams','items', require('./dashboardFormCtrl')]);
app.directive('formChart', [require('./chartDirective')]);
app.config(['$stateProvider', require('./dashboardFormConfig')]);
